
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homes/guides/[...name]",
      function () {
        return require("private-next-pages/homes/guides/[...name].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homes/guides/[...name]"])
      });
    }
  